export default __webpack_public_path__ + "static/home-banner-f9ebfa882fc509050baf5df2d039a4fb.png";